import React from "react";

const TechnologyTiles = (props) => {
  const { filterButtons, isActive, setFilter, rolesFilterHandler } = props;
  let styleClass = (button) => isActive(button);
  return (
    <div className="tab-pane active in row">
      <div className="filters text-center ">
        <ul className="nav nav-pills">
          {filterButtons.map((button, index) => {
            return (
              <li
                className={styleClass(button)}
                id={index}
                key={index}
                onClick={() => setFilter(button)}
              >
                <a onClick={() => rolesFilterHandler(button)}>{button}</a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
export default TechnologyTiles;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/TechnologyTiles/TechnologyTiles.js